import moment from 'moment';
import Validator from 'libs/Validator';
import { getMomentDateFromObject } from 'helpers/datetime';
class AccountValidator extends Validator {
    static legalAge(value) {
        const now = moment().utc();
        const birthDate = typeof value !== 'string' ? getMomentDateFromObject(value) : moment(value).utc();
        return {
            value,
            valid: !value || now.diff(birthDate, 'years', true) >= 18
        };
    }
    static newPassword(value, validatorRuleParameters, values) {
        return {
            value,
            valid: !value || !values.oldPassword || value !== values.oldPassword
        };
    }
    static dateOfBirthNotInFuture(value) {
        const now = moment();
        const birthdate = getMomentDateFromObject(value);
        return {
            value,
            valid: moment(birthdate).isBefore(now, 'day')
        };
    }
}
export { AccountValidator as default };
